import React from 'react';
import IdentityContext from '../contexts/identity-context';

export default function useIdentity() {
  return React.useContext(IdentityContext);
}
